import React from "react";

import { useEmbedParametersContext } from "../../contexts/embedParametersContext";
import i18n from "../../service/i18n";
import { usePlayerStore } from "../../store/usePlayerStore";
import { ErrorPayloadType } from "../../types/common";

import { NonPlayableContent } from "./NonPlayableContent";

const isErrorType = (error?: ErrorPayloadType): error is globalThis.Error =>
  error instanceof globalThis.Error;

export const Error = () => {
  const { useStoreState } = usePlayerStore();
  const error = useStoreState.error();
  const { language } = useEmbedParametersContext();

  const isNotFoundError =
    error && isErrorType(error) && error.message === "API responds with 404";
  const translateKey = isNotFoundError
    ? "toistettavaa_mediaa_ei_loytynyt"
    : "ei_voi_toistaa";

  return (
    <NonPlayableContent>{i18n(translateKey, { language })}</NonPlayableContent>
  );
};
